import { render, staticRenderFns } from "./SXQM.vue?vue&type=template&id=b4ca38f4&scoped=true&"
import script from "./SXQM.vue?vue&type=script&lang=js&"
export * from "./SXQM.vue?vue&type=script&lang=js&"
import style0 from "./SXQM.vue?vue&type=style&index=0&id=b4ca38f4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ca38f4",
  null
  
)

export default component.exports